import lang from '@/lang'

export const checkRequiredVatFieldsAreSet = (dataToValidate) => {
  const { taxForms: { requiredVatFields } } = lang
  const result = {
    isValid: true,
    fieldNames: [],
    messages: [],
  }

  Object.values(requiredVatFields).forEach(({ fields, text }) => {
    const partIsValid = fields.every(field => (dataToValidate[field] || '').trim().length > 0)
    if (!partIsValid) {
      result.isValid = false
      result.fieldNames.push(...fields)
      result.messages.push(text)
    }
  })

  return result
}
